import http from 'Services/HttpService';

import { baseUrl } from 'Utils/envLoader';

const DepartementService = {
    getDepartementById: (id) => {
        return http.get(`${baseUrl}/cliami/departements/${id}`);
    },

    getDepartements: () => {
        return http.get(`${baseUrl}/cliami/departements`);
    },

    saveDepartement: (departement) => {
        if (!departement.departementId) {
            return http.post(`${baseUrl}/cliami/departements/create`, departement);
        } else {
            return http.put(`${baseUrl}/cliami/departements/update/${departement.departementId}`, departement);
        }
    },

    deleteDepartement: (departement) => {
        return http.delete(`${baseUrl}/cliami/departements/delete/${departement.departementId}`);
    },
};

export default DepartementService;
